<div class="technologies-page">

  <div class="background-glow"></div>

  <app-header></app-header>

  <section class="technologies-section">

    <div class="section-header">

      <span class="section-tag">
        TECNOLOGIAS
      </span>

      <h2>
        Base tecnológica sólida para acelerar decisões e operações
      </h2>

      <p>
        Utilizamos tecnologias robustas, linguagens consolidadas e inteligência artificial
        para garantir qualidade, integração e escalabilidade.
      </p>

    </div>

    <div class="technologies-grid">

      <div class="technology-card">

        <img
          src="images/angular.png"
          alt="Angular"
        >

        <h3>
          Angular
        </h3>

        <p>
          Frontend moderno e performático.
        </p>

      </div>

      <div class="technology-card">

        <img
          src="images/springboot.png"
          alt="SpringBoot"
        >

        <h3>
          Spring Boot
        </h3>

        <p>
          Backend seguro e escalável.
        </p>

      </div>

      <div class="technology-card">

        <img
          src="images/docker.png"
          alt="Docker"
        >

        <h3>
          Docker
        </h3>

        <p>
          Containers padronizados.
        </p>

      </div>

      <div class="technology-card">

        <img
          src="images/grafana.png"
          alt="Grafana"
        >

        <h3>
          Grafana
        </h3>

        <p>
          Observabilidade avançada.
        </p>

      </div>

      <div class="technology-card">
        <img src="images/artificial-intelligence.svg" alt="Inteligência Artificial">
        <h3>Inteligência Artificial</h3>
        <p>IA integrada a produtos, processos e decisões de negócio.</p>
      </div>

      <div class="technology-card">
        <img src="https://cdn.simpleicons.org/vite/646CFF" alt="Vite">
        <h3>Vite</h3>
        <p>Ferramentas rápidas para experiências web modernas.</p>
      </div>

      <div class="technology-card">
        <img src="https://cdn.simpleicons.org/react/61DAFB" alt="React">
        <h3>React</h3>
        <p>Interfaces componentizadas e interativas.</p>
      </div>

      <div class="technology-card">
        <img src="https://cdn.simpleicons.org/nodedotjs/5FA04E" alt="Node.js">
        <h3>Node.js</h3>
        <p>Serviços JavaScript eficientes no backend.</p>
      </div>

      <div class="technology-card">
        <img src="https://cdn.simpleicons.org/javascript/F7DF1E" alt="JavaScript">
        <h3>JavaScript</h3>
        <p>Experiências web dinâmicas e integradas.</p>
      </div>

      <div class="technology-card">
        <img src="https://cdn.simpleicons.org/python/3776AB" alt="Python">
        <h3>Python</h3>
        <p>Automação, dados e aplicações com IA.</p>
      </div>

      <div class="technology-card">
        <img src="https://cdn.simpleicons.org/swift/F05138" alt="Swift">
        <h3>Swift</h3>
        <p>Aplicativos nativos para o ecossistema Apple.</p>
      </div>

      <div class="technology-card">
        <img src="https://cdn.simpleicons.org/openjdk/FFFFFF" alt="Java">
        <h3>Java</h3>
        <p>Backends corporativos sólidos e escaláveis.</p>
      </div>

      <div class="technology-card">
        <img src="https://cdn.simpleicons.org/kotlin/7F52FF" alt="Kotlin">
        <h3>Kotlin</h3>
        <p>Desenvolvimento moderno para backend e mobile.</p>
      </div>

      <div class="technology-card">
        <img src="https://cdn.simpleicons.org/cplusplus/00599C" alt="C++">
        <h3>C++</h3>
        <p>Performance para soluções de alto desempenho.</p>
      </div>

      <div class="technology-card">
        <img src="images/cobol.svg" alt="COBOL">
        <h3>COBOL</h3>
        <p>Integração e modernização de sistemas legados.</p>
      </div>

      <div class="technology-card">
        <img src="https://cdn.simpleicons.org/apple/FFFFFF" alt="Objective-C">
        <h3>Objective-C</h3>
        <p>Manutenção e evolução de aplicações Apple legadas.</p>
      </div>

    </div>

  </section>

  <section class="benefits-section">

    <div class="benefit-card">

      <div class="benefit-icon security-icon" aria-hidden="true">⌾</div>

      <h3>
        Segurança
      </h3>

      <p>
        JWT, criptografia e proteção de APIs.
      </p>

    </div>

    <div class="benefit-card">

      <div class="benefit-icon observability-icon" aria-hidden="true">◌</div>

      <h3>
        Observabilidade
      </h3>

      <p>
        Logs, métricas e traces centralizados.
      </p>

    </div>

    <div class="benefit-card">

      <div class="benefit-icon scalability-icon" aria-hidden="true">☁</div>

      <h3>
        Escalabilidade
      </h3>

      <p>
        Arquitetura preparada para cloud.
      </p>

    </div>

    <div class="benefit-card">

      <div class="benefit-icon performance-icon" aria-hidden="true">↗</div>

      <h3>
        Performance
      </h3>

      <p>
        Soluções otimizadas para alta demanda.
      </p>

    </div>

  </section>

  <section class="cta-section">

    <div class="cta-content">

      <div class="cta-left">

        <img
          src="images/technology-cta.svg"
          alt="Ilustração de crescimento tecnológico"
        >

      </div>

      <div class="cta-right">

        <h2>
          Pronto para transformar
          sua operação?
        </h2>

        <p>
          Descubra como a plataforma pode
          elevar sua arquitetura para outro nível.
        </p>

        <a
          routerLink="/login"
          class="primary-button"
        >
          Fazer Login
        </a>

      </div>

    </div>

  </section>

</div>
